"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkCarouselFragment = void 0;
var _fetching = require("@ori/fetching");
const linkCarouselFragment = exports.linkCarouselFragment = (0, _fetching.gql)`
  fragment LinkCarousel on EditorialLinkCarousel {
    __typename
    id
    title
    linkItems {
      imageUrl
      __typename
      downloadable
      title
      link {
        __typename
        id
        relativeUrl
        title
        type
        appLink {
          __typename
          link
          deepLink
        }
      }
    }
  }
`;
